import MSfbBtn from '../images/MikeShelbyFBBtn402.jpg';

function MSfbBtnEmbed(){
    return (
        <>
        <img src={MSfbBtn} alt="Mike Shelby Facebook Button" className="faithImage embedRound" />
        </>
    );
};
export default MSfbBtnEmbed;